
import { EpimsBaseEntityDto } from './epim-base.dto';

import { IsNotEmpty } from 'class-validator';

export class ProjectPaymentDto extends EpimsBaseEntityDto {

  @IsNotEmpty() ProjectPaymentId: string;
  @IsNotEmpty() Amount: number;
  @IsNotEmpty() InvoiceNo: string;
  @IsNotEmpty() PaymentDate: Date;
  @IsNotEmpty() BeneficiaryId: string;
  @IsNotEmpty() PaymentDescription: string;
  @IsNotEmpty() ProjectId: string;
                CurrencyId: string;

}
